import VirtualCard from './VirtualCard';

export default VirtualCard;
